import { GIPIBaseAbstractModel } from '@gipi-shared/models/base-abstract.model';

export class RegistrationCountry extends GIPIBaseAbstractModel {

    code: string;

    name: string;

    acronym: string;

}
